import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import moment from "moment";
import appUrl from "../../../config/appUrl";

const StateDetails = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const fromDate = queryParams.get("fromDate");
    const toDate = queryParams.get("toDate");
    const type = queryParams.get("type");
    const site = queryParams.get("site");

    const [dashList, setDashList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [vehicleTypeList, setVehicleTypeList] = useState([]);
    const [selectedVehicleType, setSelectedVehicleType] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [globalFilterValue, setGlobalFilterValue] = useState("");

    const getDashData = async (page = 1, pageSize = 10, searchText = "") => {
        try {
            setLoading(true);
            setDashList([]);
            let notCheckOutOnlyParam = "";
            if (type === "totalParked") {
                notCheckOutOnlyParam = "&notCheckOutOnly=true";
            }
             else if (type === "totalExit") {
                notCheckOutOnlyParam = "&notCheckOutOnly=false";
            }
            const url = `${appUrl.BASE_URL}parkingHistory/getActivityDetail?fromDate=${fromDate}&toDate=${toDate}&site=${site || ""}&page=${page}&pageSize=${pageSize}${notCheckOutOnlyParam}`;
            const response = await fetch(url);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

            const result = await response.json();
            let allData = result?.data?.data || [];
            const apiTotalRecords = result?.data?.totalRecords || 0;
            // Type ke basis pe filter
          
            // totalEnter = no filterF

            // Search filter
            if (searchText) {
                allData = allData.filter(item =>
                    (item?.vehicleRegNumber || "").toLowerCase().includes(searchText.toLowerCase())
                );
            }

            const myData = allData.map(item => ({
                _id: item._id,
                vehicleRegNumber: item?.vehicleRegNumber,
                vehicleType: item?.vehicleType?.name,
                checkInBy: item?.checkInBy?.boothId?.name,
                name: item?.checkInLoginUser?.firstName,
                checkInTime: item?.checkInTime ?? null,
                checkOutBy: item?.checkOutBy?.boothId?.name,
                checkOutTime: item?.checkOutTime ?? null,
                parkingFee: item?.parkingFee,
                parkedTime: item?.parkedTime,
                site: item?.site?.site,
                exempted: item?.exempted,
            }));

            setDashList(myData);
            setTotalRecords(apiTotalRecords);
        } catch (error) {
            console.error(error);
            setDashList([]);
            setTotalRecords(0);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getDashData(1, currentPageSize);
    }, [fromDate, toDate, selectedVehicleType, type]);

    const formatParkedTime = (minutes) => {
        if (!minutes && minutes !== 0) return "-";
        return `${minutes} min`;
    };

    return (
        <div>
            <div className="flex mb-3">
                <InputText
                    placeholder="Search Registration"
                    value={globalFilterValue}
                    onChange={(e) => {
                        setGlobalFilterValue(e.target.value);
                        getDashData(1, currentPageSize, e.target.value);
                        setCurrentPage(1);
                    }}
                    className="mr-3"
                />
                <Dropdown
                    value={selectedVehicleType}
                    options={vehicleTypeList}
                    optionLabel="name"
                    optionValue="_id"
                    placeholder="Select Vehicle Type"
                    onChange={(e) => setSelectedVehicleType(e.value)}
                    showClear
                />
            </div>

            <DataTable
                value={dashList}
                paginator
                rows={currentPageSize}
                totalRecords={totalRecords}
                first={(currentPage - 1) * currentPageSize}
                onPage={(e) => {
                    const newPage = e.page + 1;
                    const newPageSize = e.rows;
                    setCurrentPage(newPage);
                    setCurrentPageSize(newPageSize);
                    getDashData(newPage, newPageSize, globalFilterValue);
                }}
                loading={loading}
                lazy
                scrollable
                emptyMessage="No records found"
            >
                <Column header="ID" body={(rowData) => `${rowData._id?.slice(0, 6)}...${rowData._id?.slice(-6)}`} />
                <Column field="site" header="Site Name" />
                <Column field="vehicleType" header="Vehicle" />
                <Column field="vehicleRegNumber" header="Registration" />
                <Column
                    field="checkInTime"
                    header="Check-In"
                    body={(rowData) => rowData.checkInTime ? moment.utc(rowData.checkInTime).format("hh:mm:ss A YYYY-MM-DD") : '-'}
                />
                <Column field="checkInBy" header="Check-In Booth" />
                <Column
                    field="checkOutTime"
                    header="Check-Out"
                    body={(rowData) => rowData.checkOutTime ? moment.utc(rowData.checkOutTime).format("hh:mm:ss A YYYY-MM-DD") : '-'}
                />
                <Column field="checkOutBy" header="Check-Out Booth" />
                <Column
                    field="parkingFee"
                    header="Parking Fee"
                    body={(rowData) => new Intl.NumberFormat("en-PK", { style: "currency", currency: "PKR" }).format(rowData.parkingFee)}
                />
                <Column
                    field="parkedTime"
                    header="Park Time"
                    body={(rowData) => formatParkedTime(rowData.parkedTime)}
                />
            </DataTable>
        </div>
    );
};

export default StateDetails;
